import React from 'react';
import { FormInput } from 'components/form';
import { EquipmentDynamicFieldsProps } from '../../../types';

export const NumericField = ({
  label,
  fact,
  value,
  onChange,
  helperText,
  error,
  dataTestId,
}: EquipmentDynamicFieldsProps) => (
  <FormInput
    error={error}
    value={value}
    variant="standard"
    dataTestId={dataTestId}
    helperText={error ? helperText : ''}
    onChange={value => onChange(value)}
    label={label ?? fact.factKey.replace(/_/g, ' ')}
  />
);
